import React from "react";
import GradesHeader from "screens/grades/GradesHeader";
import { useEntity } from "student-front-commons/src/hooks";
import { COMPANY_SCHEMA, PROFILE_SCHEMA } from "student-front-commons/src/schemas";

function GradesHeaderContainer() {
  const student = useEntity(PROFILE_SCHEMA, sessionStorage.getItem("id"));
  const company = useEntity(COMPANY_SCHEMA, student.company);

  return (
    <GradesHeader
      student={student.name}
      teacher={student.techer?.name}
      school={company.name}
      maximumGrade={company.maximumGrade}
      weeklyHoursRequired={student.weeklyHoursRequired}
    />
  );
}

export default GradesHeaderContainer;
